var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      _vm.app.theme_loaded ? _c("meeting-recording-system-bar") : _vm._e(),
      _vm.app.theme_loaded
        ? _c(
            "v-main",
            { class: _vm.getBackgroundClass },
            [_c("router-view")],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }